// extracted by mini-css-extract-plugin
export default {"email":"EmailLink-module--email--714c0"};